import React from 'react'
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import HeroBanner from "../components/News/HeroBanner/HeroBanner"
import PostsList from "../components/News/PostsList/PostsList"
import ExploreMission from "../components/GlobalComponents/ExploreMill/ExploreMission"

export default function NewsCategoryTemplate({ data }) {
  const { title, metaDesc } = data.wpCategory.seo
  const pagedata = data.allWpPost
  return (
    <Layout>
      <Seo title={title} description={metaDesc} />
      <HeroBanner data={pagedata} />
      <PostsList data={pagedata} />
      <ExploreMission />
    </Layout>
  )
}

export const pagequery = graphql`
  query ($id: String!) {
    wpCategory(id: {eq: $id}) {
      seo {
        title
        metaDesc
      }
    }
    allWpPost (filter: { categories: { nodes: { elemMatch: { id: { eq: $id } } } } })  {
      nodes {
        featuredImage {
          node {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
              publicURL
            }
          }
        }
        date(formatString: "DD MMM YYYY")
        title
        categories {
          nodes {
            name
            uri
            slug
          }
        }
        uri
        author {
          node {
            name
          }
        }
      }
    }
    wp {
      aCFNewsOptions {
        aCFnewsBlueSection {
          newsContent
          newsTitle
          logoIcon {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
      }
    }
  }
`
